export default "__VITE_ASSET__t7VhFx7l__"